import { render, staticRenderFns } from "./BaseActivityView.vue.html?vue&type=template&id=3f50e260&scoped=true&"
import script from "./BaseActivityView.component.js?vue&type=script&lang=vueJs&"
export * from "./BaseActivityView.component.js?vue&type=script&lang=vueJs&"
import style0 from "./BaseActivityView.scoped.scss?vue&type=style&index=0&id=3f50e260&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f50e260",
  null
  
)

export default component.exports